<template>
    <div>
    <b-img left src="./assets/logo-megalink.png" rounded="top" fluid alt="Responsive image"  />
    <h1><b>IP-телефония</b> </h1>
    <br>
    
    <b-card>
        <b-media>
            <b-img slot="aside" src="./assets/sip.png" width="64" height = "64" alt="placeholder" />
            <h5 class="mt-0">Современный протокол связи:</h5>
            <p>
            Использование  распространённого и открытого VOIP протокола - SIP, а также популярных кодеков под различные задачи:
            от экономичного кодека <b>gsm</b> до HD кодека <b>opus</b> (помимо стандартного - <b>G711A</b>)

            </p>
        </b-media>
        <b-media>
            <b-img slot="aside" src="./assets/phone_redirect.png" width="64" height = "64" alt="placeholder" />
            <h5 class="mt-0">Переадресации</h5>
            <p class="mb-0">
                Есть возможность установить 4 вида переадресации!
            </p>
        </b-media>
        <b-media>
            <b-img slot="aside" src="./assets/vats.png" width="64" height = "64" alt="placeholder" />
            <h5 class="mt-0">Организация Виртуальных АТС</h5>
            <p class="mb-0">
                Мы также предоставляем услугу создания виртуальной АТС.
            </p>
        </b-media>
    </b-card>

    </div>
</template>

<script>
export default {
   data(){
       return {}
  },
  methods:{
      
  }
}
</script>
>


// WEBPACK FOOTER //
// src/Main.vue